import { ValidCell } from '../types';
import { BUILDINGS } from '../constants';

interface GameStateForScore {
  chosenLocationsA: ValidCell[];
  chosenLocationsB: ValidCell[];
  masterBlockedPositions: ValidCell[];
  competitorSharesMarket: boolean;
  board?: {
    [key in ValidCell]?: 'A' | 'B';
  };
}

// Bonus system: +6 for 1 team, +3 for 2 teams, +0 for 3 teams
export function getDynamicBuildingScore(
  buildingId: string,
  gameState: GameStateForScore
): number {
  const building = BUILDINGS[buildingId as keyof typeof BUILDINGS];
  if (!building) return 0;

  // Count distinct teams on adjacent positions
  let hasTeamA = false;
  let hasTeamB = false;
  let hasCompetitor = false;

  building.adjacent.forEach(pos => {
    const cell = pos as ValidCell;
    
    // Check if position is occupied by team A
    if (gameState.board?.[cell] === 'A' || gameState.chosenLocationsA.includes(cell)) {
      hasTeamA = true;
    }
    
    // Check if position is occupied by team B
    if (gameState.board?.[cell] === 'B' || gameState.chosenLocationsB.includes(cell)) {
      hasTeamB = true;
    }
    
    // Check if position is blocked by competitor (only if competitorSharesMarket is true)
    if (gameState.competitorSharesMarket && gameState.masterBlockedPositions.includes(cell)) {
      hasCompetitor = true;
    }
  });

  // Count distinct teams
  let teamCount = 0;
  if (hasTeamA) teamCount++;
  if (hasTeamB) teamCount++;
  if (hasCompetitor) teamCount++;

  // If no teams present, treat as 1 team (max bonus)
  if (teamCount === 0) teamCount = 1;

  // Apply bonus based on team count
  let bonus = 0;
  if (teamCount === 1) {
    bonus = 6;
  } else if (teamCount === 2) {
    bonus = 3;
  } else if (teamCount === 3) {
    bonus = 0;
  }

  return building.score + bonus;
}




